import { type Config } from './config.types';

// To make testing easier for components that use get config
export const MOCK_CONFIG: Config = {
    bentleyIdEnabled: false,
    bentleyIdEnabledCentral: false,
    blocksync_segmentWriteKey: 'testwritekey',
    central_segmentWriteKey: 'testwritekey',
    discovery_url: 'https://mock-discover.api.seequent.com',
    imago_segmentWriteKey: 'testwritekey',
    evo_segmentWriteKey: 'testwritekey',
    applicationInsightsConnection: 'testAppInsightsConnection',
    entitlements_url: 'https://ent-api.com',
    identity_url: 'https://id-api.com',
    environment: 'development',
    launchDarklyClientID: '123456',
    manageApi: 'https://manage.com',
    notificationsUrl: 'https://uat1.notifications.seequent.systems',
    publicStorageUrl: 'https://publicscenestest.dev.central.seequent.com/blobs',
    openStreetMapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    publicSentryDsn: 'testsentrydsn',
    xid_base_url: 'https://xid-dev.geosoft.com',
    bentleyBaseUrl: 'https://qa-ims.bentley.com',
    bentleyUserManagementUrl: 'https://qa-usermanagement.bentley.com',
};

// To make testing easier for components that use get config
export const MOCK_DEV_SLOT_CONFIG: Config = {
    bentleyIdEnabled: false,
    bentleyIdEnabledCentral: false,
    blocksync_segmentWriteKey: 'testwritekey',
    central_segmentWriteKey: 'testwritekey',
    discovery_url: 'https://mock-discover.api.seequent.com',
    imago_segmentWriteKey: 'testwritekey',
    evo_segmentWriteKey: 'testwritekey',
    applicationInsightsConnection: 'testAppInsightsConnection',
    entitlements_url: 'https://ent-api.com',
    identity_url: 'https://id-api.com',
    environment: 'development',
    launchDarklyClientID: '123456',
    manageApi: 'https://manage.com',
    notificationsUrl: 'https://uat1.notifications.seequent.systems',
    publicStorageUrl: 'https://publicscenestest.dev.central.seequent.com/blobs',
    openStreetMapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    publicSentryDsn: 'testsentrydsn',
    xid_base_url: 'https://xid-dev.geosoft.com',
    bentleyBaseUrl: 'https://qa-ims.bentley.com',
    bentleyUserManagementUrl: 'https://qa-usermanagement.bentley.com',
};

// Test data for config.overrides.json file
export const MOCK_DEV_SLOT_CONFIG_OVERRIDES: Partial<Config> & { segmentWriteKey: string } = {
    segmentWriteKey: 'testwritekeyoverride',
    environment: 'development',
    launchDarklyClientID: '987654',
    xid_base_url: 'https://xid-dev.geosoft.override.com',
};

// The expected result of applying MOCK_CONFIG_OVERRIDES onto MOCK_CONFIG
export const MOCK_DEV_CONFIG_OVERRIDDEN: Config = {
    ...MOCK_DEV_SLOT_CONFIG,
    ...MOCK_DEV_SLOT_CONFIG_OVERRIDES,
};

export const MOCK_DEV_BENTLEY_CONFIG: Config = {
    ...MOCK_CONFIG,
    bentleyIdEnabled: true,
    // TODO(CENPLAT-19624): other config that changes with Bentley
};
